export class HeaderConfig {
  headerText: string = '';
  cancelButton: boolean = false;
  backgroundCss: string = 'info-dialog__background'
}